<template>
    <div class="header">
        <header class="navbar">
            <section class="navbar-section">
                <default-button
                    v-if="is_at_least_administrator"
                    flavor="link"
                    @click.prevent="$emit('navigate', null)"
                >
                    <open-icon glyph="bars" />
                </default-button>
                <default-button
                    v-if="!!profile_id"
                    flavor="link"
                    :title="translate('Export SKUs...')"
                    class="show-sm"
                    @click.prevent="setting_up_export = true"
                >
                    <open-icon glyph="file-invoice-dollar" />
                </default-button>
                <default-button
                    v-if="!!profile_id||isPublicPage"
                    flavor="link"
                    class="show-sm"
                    @click.prevent="bug_report"
                >
                    <open-icon glyph="bug" />
                </default-button>
            </section>
            <section class="navbar-center">
                <base-link
                    :href="{ name: 'home' }"
                    @click.native="$emit('navigate', false)"
                >
                    <app-logo />
                </base-link>
            </section>
            <section class="navbar-section">
                <default-button
                    v-if="!!app_context && !!app_context.settings && app_context.settings.bug_reporter_active && (!!profile_id || isPublicPage)"
                    flavor="link"
                    class="mr-4 hide-sm"
                    @click.prevent="bug_report"
                >
                    <open-icon glyph="bug" />
                </default-button>
                <default-button
                    v-if="!!profile_id"
                    flavor="link"
                    :title="translate('Export Billables...')"
                    class="mr-4 hide-sm"
                    @click.prevent="setting_up_export = true"
                >
                    <open-icon glyph="file-invoice-dollar" />
                </default-button>
                <default-button
                    v-if="!!profile_id"
                    flavor="link"
                    :title="$root.translate('Logout')"
                    @click.prevent="logout"
                >
                    <open-icon glyph="sign-out-alt" />
                </default-button>
                <default-button
                    v-else-if="!profile_id"
                    flavor="link"
                    :title="$root.translate('Login/Signup')"
                    @click.prevent="login"
                >
                    <open-icon glyph="sign-in-alt" />
                </default-button>
                <base-link
                    :href="{ name: 'profile' }"
                    class="btn btn-link"
                >
                    <figure class="avatar avatar-sm">
                        <open-icon v-if="!profile_id||(!!profile&&!profile.avatar)" glyph="user" size="2x" />
                        <img v-else :src="profile.avatar" :alt="profile.name">
                    </figure>
                </base-link>
            </section>
        </header>
        <billables-export-dialog
            :show.sync="setting_up_export"
        />
    </div>
</template>

<script>
import { profile_utilities } from "@/nibnut/mixins"

import { DefaultButton, BaseLink, OpenIcon } from "@/nibnut/components"
import { AppLogo } from "@/custom/components"
import { BillablesExportDialog } from "@/custom/dialogs"

export default {
    mixins: [profile_utilities],
    components: {
        AppLogo,
        DefaultButton,
        BaseLink,
        OpenIcon,
        BillablesExportDialog
    },
    methods: {
        bug_report () {
            this.$emit("bug-report")
        },
        login () {
            this.$store.dispatch("REQUEST_LOGIN", { panel_id: true })
        },
        logout () {
            this.$store.dispatch("LOGOUT")
        }
    },
    props: {
        isPublicPage: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            setting_up_export: false
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/variables";

.header {
    .navbar-section:first-child {
        padding-left: 0.3rem;
    }
    .btn {
        border: 0;

        i {
            font-size: 1rem;
        }
    }
}
</style>
